import { render, staticRenderFns } from "./s200app.vue?vue&type=template&id=31152fac&scoped=true&"
import script from "./s200app.vue?vue&type=script&lang=js&"
export * from "./s200app.vue?vue&type=script&lang=js&"
import style0 from "./s200app.vue?vue&type=style&index=0&id=31152fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31152fac",
  null
  
)

export default component.exports